module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-00.7bd6d367.png";